import { useTRPC } from "@/trpc";
import { FieldValues, UseFormReturn } from "react-hook-form";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { MatchFilterState } from "@/pages/app/matches/(context)/filter";

export const useCreateFilter = <T extends FieldValues>(form: UseFormReturn<T>, page: string, userId: string, name: string, onSuccess?: () => void) => {
  const qc = useQueryClient();
  const { trpc } = useTRPC();


  return useMutation({
    mutationFn: async () => {
      const values = form.getValues();
      let filters: { field: string; value: string; display: string }[] = [];
      if (page === "MATCHES") {
        filters = buildMatchFiltersFromValues(values);
      }

      return trpc.filters.create.mutate({
        user_id: userId,
        filter_name: name,
        filter: { page: page, filters },
      });
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['filters'] }); 
      onSuccess?.();
    },
    onError: (error) => {
      console.error('Failed to create filter:', error);
    },
    });
  };

const buildMatchFiltersFromValues = (values: MatchFilterState) => {
  const { search, competition, daterange } = values;
  return [
    ...(search ? [{ field: 'search', value: search, display: search }] : []),
    ...(competition?.competition_id ? [{ field: 'competitie', value: competition.competition_id, display: competition.competition_name || competition.competition_id }] : []),
    ...(competition?.club_id ? [{ field: 'club', value: competition.club_id, display: competition.club_name || competition.club_id }] : []),
    ...(daterange?.date_from ? [{ field: 'datum van', value: daterange.date_from, display: daterange.date_from_display || daterange.date_from }] : []),
    ...(daterange?.date_to ? [{ field: 'datum tot', value: daterange.date_to, display: daterange.date_to_display || daterange.date_to }] : []),
  ];
};